import { useJournalStore } from '../hooks/useJournalStore';
import type { WidgetProps } from './WidgetRegistry';

export function DraftViewerWidget(_props: WidgetProps) {
  const journal = useJournalStore((s) => s.activeJournal);
  if (!journal) return <div className="text-tower-muted text-sm p-3">No journal loaded</div>;

  const draft = journal.rootContinuation.state.workingDraft;

  return (
    <div className="p-3 overflow-y-auto h-full">
      {!draft && <div className="text-tower-muted text-sm">No working draft yet. The continuation will produce a draft after processing findings.</div>}
      {draft && (
        <div className="prose prose-sm prose-invert max-w-none">
          <pre className="whitespace-pre-wrap text-sm text-tower-text font-sans leading-relaxed">{draft}</pre>
        </div>
      )}
      <div className="mt-3 flex gap-2 text-xs text-tower-muted">
        <span>Tick {journal.rootContinuation.state.tickCount}</span>
        {journal.rootContinuation.state.lastTickAt && (
          <span>&middot; Last tick: {new Date(journal.rootContinuation.state.lastTickAt).toLocaleString()}</span>
        )}
        <span>&middot; Open questions: {journal.rootContinuation.state.openQuestions.length}</span>
      </div>
      {journal.rootContinuation.state.openQuestions.length > 0 && (
        <div className="mt-2 space-y-1">
          {journal.rootContinuation.state.openQuestions.map((q, i) => (
            <div key={i} className="text-xs text-tower-warning bg-tower-warning/10 px-2 py-1 rounded">
              {i + 1}. {q}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
